import { render, staticRenderFns } from "./ResendConfirmationEmail.vue?vue&type=template&id=f0597ca6&scoped=true&"
import script from "./ResendConfirmationEmail.vue?vue&type=script&lang=js&"
export * from "./ResendConfirmationEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResendConfirmationEmail.vue?vue&type=style&index=0&id=f0597ca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0597ca6",
  null
  
)

export default component.exports